/**
 * @generated SignedSource<<222acd2184a1decb1bf8bd592aa03d2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SalesforceFieldInteractionType = "AI_SUGGESTION" | "EDITABLE" | "VIEW_ONLY";
export type SalesforceCardsQuery$variables = {
  emails: ReadonlyArray<string>;
};
export type SalesforceCardsQuery$data = {
  readonly salesforceObjectsForEmails: ReadonlyArray<{
    readonly __typename: "SalesforceObjectRecord";
    readonly fields: ReadonlyArray<{
      readonly interactionType: SalesforceFieldInteractionType;
      readonly label: string;
      readonly length: number | null;
      readonly name: string;
      readonly type: string;
      readonly value: string | null;
    }>;
    readonly id: string;
    readonly label: string;
    readonly name: string;
    readonly references: ReadonlyArray<{
      readonly fields: ReadonlyArray<{
        readonly interactionType: SalesforceFieldInteractionType;
        readonly label: string;
        readonly length: number | null;
        readonly name: string;
        readonly type: string;
        readonly value: string | null;
      }>;
      readonly id: string;
      readonly label: string;
      readonly name: string;
      readonly url: string;
      readonly value: string | null;
    }>;
    readonly url: string;
    readonly value: string | null;
  }> | null;
  readonly viewer: {
    readonly account: {
      readonly integrations: {
        readonly salesforce: {
          readonly isConnected: boolean;
        } | null;
      };
    };
  };
};
export type SalesforceCardsQuery = {
  response: SalesforceCardsQuery$data;
  variables: SalesforceCardsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "emails"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesforceFieldData",
  "kind": "LinkedField",
  "name": "fields",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "interactionType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "length",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "emails",
      "variableName": "emails"
    }
  ],
  "concreteType": "SalesforceObjectRecord",
  "kind": "LinkedField",
  "name": "salesforceObjectsForEmails",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesforceObjectRecord",
      "kind": "LinkedField",
      "name": "references",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SalesforceCardsQuery",
    "selections": [
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesforceWorkspaceConfigurationNode",
                    "kind": "LinkedField",
                    "name": "salesforce",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SalesforceCardsQuery",
    "selections": [
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesforceWorkspaceConfigurationNode",
                    "kind": "LinkedField",
                    "name": "salesforce",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cf5f6928f02e049b3229d1aedf10ebcb",
    "id": null,
    "metadata": {},
    "name": "SalesforceCardsQuery",
    "operationKind": "query",
    "text": "query SalesforceCardsQuery(\n  $emails: [String!]!\n) {\n  salesforceObjectsForEmails(emails: $emails) {\n    __typename\n    name\n    label\n    value\n    id\n    url\n    fields {\n      name\n      label\n      value\n      type\n      interactionType\n      length\n    }\n    references {\n      name\n      label\n      value\n      id\n      url\n      fields {\n        name\n        label\n        value\n        type\n        interactionType\n        length\n      }\n    }\n  }\n  viewer {\n    account {\n      integrations {\n        salesforce {\n          isConnected\n          id\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c25b10c9aa44d497fb46114ec544db58";

export default node;
